import axiosInstance from './axiosInstance'
import {
  TRASLADOS_LIST_PATH,
  trasladoAnularPath,
  trasladoByIdPath,
  trasladoReenviarFlexyPath
} from '../constants/trasladosApiPaths'
import type {
  CreateTrasladoPayload,
  Traslado,
  TrasladoDetailResponse,
  TrasladosFilters,
  TrasladosListResponse
} from '../types/traslados'
import { normalizeTraslado, normalizeTrasladosList } from '../utils/trasladosMapper'

export interface TrasladosListResult {
  success?: boolean
  message?: string
  data: Traslado[]
  pagination?: TrasladosListResponse['pagination']
}

class TrasladosService {
  async getTraslados(filters: TrasladosFilters = {}): Promise<TrasladosListResult> {
    const params = new URLSearchParams()
    if (filters.estado) {
      const estadoValue = Array.isArray(filters.estado)
        ? filters.estado.filter(Boolean).join(',')
        : filters.estado
      if (estadoValue) params.append('estado', estadoValue)
    }
    if (filters.page) params.append('page', String(filters.page))
    if (filters.limit) params.append('limit', String(filters.limit))

    const query = params.toString()
    const url = query ? `${TRASLADOS_LIST_PATH}?${query}` : TRASLADOS_LIST_PATH
    const response = await axiosInstance.get<TrasladosListResponse>(url)

    return {
      ...response.data,
      data: normalizeTrasladosList(response.data.data)
    }
  }

  async getTrasladoById(id: number | string): Promise<Traslado> {
    const response = await axiosInstance.get<TrasladoDetailResponse>(trasladoByIdPath(id))
    return normalizeTraslado(response.data.data)
  }

  async createTraslado(payload: CreateTrasladoPayload): Promise<Traslado> {
    const response = await axiosInstance.post<TrasladoDetailResponse>(TRASLADOS_LIST_PATH, payload)
    return normalizeTraslado(response.data.data)
  }

  async updateTraslado(
    id: number | string,
    payload: Partial<CreateTrasladoPayload>
  ): Promise<Traslado> {
    const response = await axiosInstance.patch<TrasladoDetailResponse>(trasladoByIdPath(id), payload)
    return normalizeTraslado(response.data.data)
  }

  async anularTraslado(id: number | string): Promise<Traslado> {
    const response = await axiosInstance.post<TrasladoDetailResponse>(trasladoAnularPath(id))
    return normalizeTraslado(response.data.data)
  }

  async reenviarFlexy(id: number | string, force = false): Promise<Traslado> {
    const response = await axiosInstance.post<TrasladoDetailResponse>(
      trasladoReenviarFlexyPath(id, force)
    )
    return normalizeTraslado(response.data.data)
  }
}

export const trasladosService = new TrasladosService()
export default trasladosService
